import store from '../store';
import trackingConfig, { eventValueMap, mandatoryFields } from '../assets/trackingFields';
import ReactHtmlParser from "react-html-parser";
import { appNavigateTo } from "../store/actions/navActions";
import { funcFetchMasterData, funcFetchCityData, funcFetchBankListData } from "../store/actions/MasterDataActions";
import { funcGetPartnerData, isPartnerChannelCode, getPartnerName, isNonbankaPartnerChannelCode, isPartnerLeadSource, isNonbankaPartner } from "./PartnerUtility";
import * as types from '../store/types';
export const simplifyJson = (json, key) => {
  let data = !key ? json : json[key];
  if (key === "errors") {
    let errorMap = {};
    if (Array.isArray(data)) {
      errorMap = data.reduce((ov, nv) => {
        ov[nv.id] = nv.msg;
        return ov;
      }, {});
    } else if (typeof data === "object") {
      errorMap[data.id] = data.msg;
    }
    json[key] = errorMap;
  } else if (typeof data === "object") {
    for (let k in data) {
      simplifyJson(data, k);
    }
  }
};
export const functionSanitizeFilename = (filename) => {
  const splitedFile = filename.split(".");
  const ext = splitedFile.pop();
  const name = splitedFile.shift();
  const newFilename = name.replaceAll(" ", "_").slice(0, 20 - ext.length - 1) + "." + ext;

  return newFilename;
}
export const isValidAge = (str, minAge, maxAge) => {
  const calculateAge = (dob, dt) => {
    dt = dt || new Date();
    var diff = dt.getTime() - new Date(dob).getTime();
    return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
  };
  const convertDatetoUSFormat = (date) => {
    const arr = date.split("/");
    const temp = arr[1];
    arr[1] = arr[0];
    arr[0] = temp;
    return arr.join("/");
  };
  return calculateAge(convertDatetoUSFormat(str)) >= minAge &&
    calculateAge(convertDatetoUSFormat(str)) <= maxAge
}
export const funcGenerateUniqueKey = () => {
  var uid = "",
    i = 0;
  while (i++ < 36) {
    var c = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"[i - 1],
      r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    uid += c === "-" || c === "4" ? c : v.toString(16);
  }
  return uid;
};

export const getAddress = (stpAddressList, addressType) => {
  return stpAddressList.filter(addr => addr.addressType === addressType);
}

export const getVkycReason = (vkycAgentDecision,vkycAgentDecisionReason) =>{
  if(!vkycAgentDecisionReason){
    return "others"
  }
  const val = window.global.config?.VKYC_Reason.find(entry => entry[vkycAgentDecision]);
  if(val){
    const reasons = val[vkycAgentDecision];
    const foundReason = reasons.filter(reasonObj => reasonObj.reason.trim() === vkycAgentDecisionReason.trim())[0];
    if(foundReason){
      return foundReason.reasonCode
    }
    else{
      return "others";
    }
  }
}


export const getSection = (goTo = "") => {
  const path = goTo.toLowerCase();
  if (
    path.includes("personaldetail") ||
    path === "otpview" ||
    path === "city" ||
    path === "pan" ||
    path === "email" ||
    path === "changeffno"
  ) {
    return "personalDetails";
  } else if (path === "professional" || path === "officeaddress") {
    return "professionalDetails";
  } else if (
    path === "resiaddress" ||
    path === "gender" ||
    path === "kycdetails" ||
    path === "digiconsent" ||
    path === "digipage" ||
    path === "digisuccess" ||
    path === "digitimeout" ||
    goTo === "takePhoto" ||
    goTo === "penydrop" ||
    goTo === "account" ||
    goTo === "debit" ||
    goTo === "credit" ||
    goTo === "penySuccess" ||
    goTo === "penyFailure" ||
    goTo === "validateOTP" ||
    goTo === "vkycOptionScreen" ||
    goTo === "telcoValidateOTP" ||
    goTo === "incomeSurrogate" ||
    goTo === "accountAggregatorStatus" ||
    goTo === "posStatus" ||
    goTo === "conditionalMITC" ||
    goTo === "GstOptionScreen" 
  ) {
    return "kycDetails";
  }
};

export const getBannerFlag = (cardtype) => {
  if (window.global.config?.BANNER_CARDS) {
    return window.global.config.BANNER_CARDS.indexOf(cardtype) > -1
  }
}

export const getResiVeribage = (
  veribageArray,
  resiFlags,
) => {
  const veribages = {
    headerMsg: "",
    subHeaderMsg: "",
    inputHeaderMsg: "",
    inputText: "",
    inputSubMsg: {
      MANUAL: "",
      DIGI: "",
      DEMOG: "",
    },
    footerMsg: "",
  };

  if (resiFlags.screenFlow === 'kycAddress') {
    veribages.headerMsg = veribageArray[0];
    veribages.subHeaderMsg = veribageArray[2];
    veribages.inputHeaderMsg = veribageArray[15];
    veribages.inputText = veribageArray[4];
    veribages.footerMsg = veribageArray[9];
  } else if (resiFlags.screenFlow === 'digiDenyDemoAndManual') {
    veribages.headerMsg = veribageArray[10];
    veribages.subHeaderMsg = veribageArray[11];
    veribages.inputHeaderMsg = veribageArray[12];
    veribages.inputText = veribageArray[5];
    veribages.inputSubMsg.DIGI = veribageArray[17];
    // veribages.inputSubMsg.MANUAL = veribageArray[18];
    veribages.footerMsg = veribageArray[7];
  } else if (resiFlags.screenFlow === 'demoAndManual') {
    veribages.headerMsg = veribageArray[0];
    veribages.inputHeaderMsg = veribageArray[15];
    veribages.inputText = veribageArray[5];
    veribages.footerMsg = veribageArray[7];
    veribages.footerMsg = veribageArray[9];
  } else if (resiFlags.screenFlow === 'digiAndOther' || resiFlags.screenFlow === 'digiAndManual') {
    veribages.headerMsg = veribageArray[0];
    veribages.inputHeaderMsg = veribageArray[15];
    veribages.inputText = resiFlags.screenFlow === 'digiAndOther' ? veribageArray[4] : veribageArray[5];
    veribages.footerMsg = veribageArray[9];
  } else if (resiFlags.screenFlow === 'manual') {
    veribages.headerMsg = veribageArray[1];
    veribages.subHeaderMsg = veribageArray[3];
    veribages.inputHeaderMsg = veribageArray[15];
    veribages.footerMsg = veribageArray[7];
    veribages.inputText = veribageArray[5];
  }else if (resiFlags.screenFlow === 'digiSplitManual') {
    veribages.headerMsg =  veribageArray[22];;
    veribages.subHeaderMsg =  veribageArray[23];;
    veribages.inputHeaderMsg = veribageArray[15];
    veribages.footerMsg = veribageArray[7];
    veribages.inputText = veribageArray[5];
  }
  return veribages;
}

export const funcGetUpdatedVisionAddr = (updatedVisionAddress, masterAddress, vpin) => {
  if(masterAddress && masterAddress != null){
    let filteredPin = masterAddress.filter((ele, i) => {
    return (ele.pin.indexOf(vpin) >= 0);
  })
  if (filteredPin.length > 0) {
    updatedVisionAddress = [{...updatedVisionAddress, state: filteredPin[0].state, city: filteredPin[0].name }]
  }
  else {
    updatedVisionAddress = [];
  }}
  return updatedVisionAddress;
}

export const getResiAddrObject = (address, gender, addressType) => {
  return address.map((addr, i) => {
    addr.gender = gender;
    addr.addressType = addr.addressType ? addr.addressType : addressType;
    return addr;
  });
};

export const getVisionAddress = (vArray) => {
  if(vArray && vArray != null){
  let visionAdd = vArray.map((ele) =>
  ({
    resiAddressLine1: ele.addressLine1,
    locality: "",
    resiAddressLine2: ele.addressLine2,
    pin: ele.pin,
    state: ele.state,
    city: ele.city,
    addressType:"VISIONPLUS",
    landmark: ""
  }))

  return visionAdd;
}
}

export const RedirectBack = () => {
  window.location.href = `${window.location.origin}/en/eapply.page`;
};

export const RedirectToHelpScreen = async (dispatch, currentAppState, userDetail, wipStatusCode) => {
  const partner = getPartnerName();
  if (partner) {
   if (isNonbankaPartner(partner)) {
    let currAction = currentAppState.currentAction;
    let milestone;
    if (wipStatusCode && (wipStatusCode?.statusCode === "ERR08" || wipStatusCode?.statusCode === "ERR05")) {
      milestone = "FinalSubmission";
    }
    else {
      switch (currAction) {
        case "applicationConscentValidated":
          milestone = "FinalSubmission";
          break;
        case "SD2Error":
          milestone = "SD2";
          break;
        case "SD2Decline":
          milestone = "SD2Decline";
          break;
        case "ECardFetchFailed":
          milestone = "CardGenerated";
          break;
        case "PennyCredit":
          milestone = "PennyDropCredit";
          break;
        case "takePhotoFailed":
          milestone = "PhotoTask";
          break;
        case "takePhoto107":
          milestone = "PhotoTask107";
          break;
        case "penyDebited":
          milestone = "PennyDropDebit_UPI";
          break;
        case "uploadPanWIp":
          milestone = "PanCardUpload";
          break;
        case "FatalError":
          milestone = "FatalError";
          break;
        default:
          milestone = "SD2"
          break;
      }
    }
    const partnerUrl = await funcGetPartnerData(partner, milestone, "failure");
    window.location.href = partnerUrl;
    }
    localStorage.removeItem("partnerRedirect");
  }
  
    dispatch({ type: "RESET_APP" });
    if (currentAppState?.cardListDetails?.cardType) {
      const cardTypeData = {
        cardType: currentAppState?.cardListDetails?.cardType,
        cardChannelCode: userDetail.channelCode,
      };
      dispatch(funcFetchMasterData(cardTypeData));
      dispatch(funcFetchBankListData(cardTypeData));
      dispatch(funcFetchCityData(cardTypeData));
    }
    dispatch(appNavigateTo({ goTo: "help" }, "APP_NAVIGATE_TO"));

};

export const findFromObject = (obj, path) => {
  path = path.split('.');
  let value = obj;
  for (let i of path) {
    if (!value[i]) {
      return;
    }
    value = value[i];
  }
  return value;
}

export const dncAuditLogObj = (trackingFieldNo, level1Detail, level2Detail, decisionCode, decisionReason, auditlogNo, auditlogTxt) => {
  const logObj = {
    trackingFieldNo,
    level1Detail,
    level2Detail,
    decisionCode,
    decisionReason,
    auditlogNo,
    auditlogTxt
  };
  return logObj;
}

export const trackPages = (type, evar3Value, fieldsValue, evar28Value, evar29Value, evar2Value) => {
  const state = store.getState();
  if (!trackingConfig[type]) {
    return;
  }
  let config = trackingConfig[type];
  let payload = {};

  for (let i of config.dynamicValues) {
    if (eventValueMap[i]) {
      if (typeof (eventValueMap[i]) === 'function') {
        payload[i] = eventValueMap[i]();
      } else {
        payload[i] = findFromObject(state, eventValueMap[i]);
      }
    }
  }

    
  for (let m of mandatoryFields) {
    if (config[m]) {
      payload[m] = config[m];
    }
  }
  if (evar3Value)
    payload.evar3 = evar3Value;
  if (payload.evar31)
    payload.evar31 = (fieldsValue && fieldsValue.otpResend) ? fieldsValue.otpResend : payload.evar31;
  payload.evar35 = (fieldsValue && fieldsValue.pinCode) ? fieldsValue.pinCode : payload.evar35;
  payload.evar25 = (fieldsValue && fieldsValue.status) ? fieldsValue.status : payload.evar25;
  payload.evar26 = (fieldsValue && fieldsValue.errorCode) ? fieldsValue.errorCode : payload.evar26;
  payload.evar27 = (fieldsValue && fieldsValue.errorMsg) ? fieldsValue.errorMsg : payload.evar27;

  if (evar28Value)
    payload.evar28 = evar28Value;
  if (evar29Value)
    payload.evar29 = evar29Value;
  if(evar2Value)
    payload.evar2 = evar2Value;
  
  if (window?.analytics?.track) {
    window?.analytics?.track(config["Event Name"], payload);
  }
}

export const isAccountValidated = (goTo) => {
  if (
    goTo === "penydrop" ||
    goTo === "account" ||
    goTo === "debit" ||
    goTo === "credit" ||
    goTo === "penySuccess" ||
    goTo === "penyFailure"
  ) {
    return true
  } else {
    return false;
  }
}

export const getMobileHeader = (goTo, getSection, cardTilePageContent) => {
  if (getSection === "personalDetails") {
    return cardTilePageContent.step_tiles.personal_detail.heading;
  } else if (getSection === "professionalDetails") {
    return cardTilePageContent.step_tiles.professional_detail.heading;
  } else if (goTo === "applicationConscent" || goTo === "validateOTP") {
    return "Application Submission";
  } else {
    return cardTilePageContent.step_tiles.kyc_details.heading;
  }
}

export const getUserNameOnCard = (userDetail) => {
  if (userDetail && userDetail?.firstName) {
    let { firstName, middleName, lastName } = userDetail;
    let name = '';

    if (middleName && `${firstName} ${middleName} ${lastName}`.length < 19) {
      name = `${firstName} ${middleName} ${lastName}`;
    } else if (`${firstName} ${lastName}`.length < 19) {
      name = `${firstName} ${lastName}`
    } else {
      name = `${firstName} ${lastName.charAt(0)}`
    }
    return name.toUpperCase();
  }
}

export const getLightColorCard = (cardtype) => {
  if (window.global.config?.LIGHT_COLOR_CARDS) {
    return window.global.config.LIGHT_COLOR_CARDS.indexOf(cardtype) > -1
  }
}
export const getDownsellcards = (cardtypes, partner,channelCode) => {
  if (window.global.config?.PAYTM_CARDS) {
    if ((partner && partner === 'paytm')||(channelCode && isNonbankaPartnerChannelCode(channelCode))) {
      return cardtypes.filter((ele) => {
        
          return window.global.config.PAYTM_CARDS.includes(ele.cardType)
        })
    }
    else {
      return cardtypes.filter(ele => !window.global.config.PAYTM_CARDS.includes(ele.cardType));
    }/*else if(partner && partner === 'BANKBAZAR') {
      return cardtypes.filter(ele => window.global.config.BANKBAZAR_CARDS.includes(ele.cardType));
    }*/
    }
}
export const getTitanEncircleCard = (cardtype) => {
  if (window.global.config?.PARTNER_COBRANDED_CHANGECARDS) {
    return window.global.config.PARTNER_COBRANDED_CHANGECARDS.indexOf(cardtype) > -1
  }
}



export const parseHtml = (htmlStr) => {
  return ReactHtmlParser(htmlStr);
}

export const compressImage = image => {

}

export const parseContent = (contentText, replaceFrom, replaceTo) => {
  const replacedText = contentText ? contentText.replace(replaceFrom, replaceTo) : "";
  return ReactHtmlParser(replacedText)
}
export const parseContentArr = (contentText, replaceFromArr, replaceToArr) => {
  let replacedText = contentText;
  replaceFromArr.forEach((element, index) => {
    replacedText = replacedText.replace(element, replaceToArr[index]);
  });
  return ReactHtmlParser(replacedText)
}

export const IsChangeCardVisible = (userDetail, applicationNumber,productType) => {
  const partner_changecards_visibility = window.global.config?.PARTNER_CHANGECARDS_VISIBILITY;
  const lg_lite_partner_chanel = window.global.config?.LG_LITE_PARTNER_CHANEL;
  const parter_cobranded_channels = window.global.config?.PARTNER_COBRANDED_CHANGECARDS;
  let localStoragegemid1 = getGEMID1();
  if  (localStorage.getItem("sourceCode") === "DC" && partner_changecards_visibility.includes(productType))
    return true;
  else if (localStoragegemid1 && parter_cobranded_channels.includes(productType))
    return false
  else if (applicationNumber || userDetail.campaign || (localStorage.getItem("sourceCode") === "DC" && !lg_lite_partner_chanel.includes(userDetail.channelCode)))
    return false;
  else if ((isPartnerChannelCode(userDetail.channelCode)  && userDetail.leadAge <= 30) || ((isNonbankaPartnerChannelCode(userDetail.channelCode) || isPartnerLeadSource(userDetail.leadSource)) && userDetail.leadAge <= 90))
    return false; //this condition is added for RT012 case when partner lead(present in LMS but application no not generated) is retrieving from sprint home page with different card. 
  else
    return true;
}

export const getTrackState = (state) =>{
let status = window.global.config?.track_Status.includes(state) ? true : false;
return status;
}

export const GetAPIErrorMsgForErrorCode = (serviceName, errorCode, errorCodeContent = []) => {
  const serviceErrorCodes = (errorCodeContent?.filter((err) => err?.actionName === serviceName)[0]?.errorContainer);
  const errorCodeMsg = serviceErrorCodes?.filter((err) => err?.errorCode === errorCode)[0]?.errorMsg;
  return errorCodeMsg || "";
}
export const getGEMID1 = () => {
  return localStorage.getItem("gemId1");
}

export const getGEMID2 = () => {
  return localStorage.getItem("gemId2");
}
export const getLastCs = () => {
  return localStorage.getItem("cShortCode");
}
export const getLastCsDatetime = () => {
  return localStorage.getItem("lastCsDatetime");
}
export const getShortCode = () => {
  return localStorage.getItem("shortCode");
}

export const getApiSubPayload = () => {
  let gemId1 = getGEMID1();
  let gemId2 = getGEMID2();
  let lastCs = getLastCs();
  let shortCode = getShortCode();
  let payload = {};
  if (gemId1 && gemId1 !== "null" && gemId1 !== "" && gemId1 !== "undefined")
    payload.gemId1 = gemId1;
  if (gemId2 && gemId2 !== "null" && gemId2 !== "" && gemId2 !== "undefined")
    payload.gemId2 = gemId2;
  if (lastCs && lastCs !== "null" && lastCs !== "")
    payload.lastCs = lastCs;
  if (shortCode && shortCode !== "null" && shortCode !== "")
    payload.shortCode = shortCode;
  return payload;
}

export const saveApplicationNumber = (applicationNumber,shortCode) => {
  localStorage.setItem("shortCode", shortCode);
  localStorage.setItem("applicationNumber", applicationNumber);
}

export const getSourceCode = () => {
  return localStorage.getItem("sourceCode");
}
export const getDeviceInfo = () => {
  return localStorage.getItem("deviceinfo");
}
// export const getCardName = (currentCardType) => {
//   let cardArray= window.global.config.MasterRedirectionCardTypes
//   let newCardData= cardArray.filter(item =>(item.originalCardName === currentCardType ))
//   let newCardName = newCardData.length > 0 ? newCardData[0].newcardName : ""
//   return newCardName
// }
export const getNetworkDetails = (currentCardKey,currentCardKeyValue,nwData) => {
   let cardArray= nwData;
   let selectedCardData = cardArray.filter(item =>(item[currentCardKey] === currentCardKeyValue ))
   return selectedCardData.length > 0 ? selectedCardData[0] : [];
 }
export const getCardType = (contentCardType, userDetailCardType) => {
  /*if(contentCardType && contentCardType !== undefined  && userDetailCardType && userDetailCardType !== undefined && contentCardType === userDetailCardType) {
    return userDetailCardType;
  }
  else */if( userDetailCardType && userDetailCardType !== undefined) {
    return userDetailCardType;
  }
  else if(contentCardType && contentCardType !== undefined) {
    return contentCardType;
  }
  else
  return "";
}
export const getDigilockerUrl = () => {
  //return process.env.REACT_APP_ENV==="DEV" ? window.global.config?.DEV_DIGI_LOCKER_URL :  window.global.config?.PROD_DIGI_LOCKER_URL ;
  return window.global.config?.REACT_APP_ENV==="DEV" ? window.global.config?.DEV_DIGI_LOCKER_URL :  window.global.config?.PROD_DIGI_LOCKER_URL ;

}
export const getMetaCardName = (currentCardName) => {
  let cardArray= window.global.config.MetaCardsName
  let newCardData= cardArray.filter(item =>(item.originalCardName === currentCardName ))
  let newCardName = newCardData.length > 0 ? newCardData[0]?.newCardName : currentCardName
  return newCardName
}

export const SurrogateRetNavigate = (MidMitc, dispatch, updateState,userDetail) => {
  if (MidMitc?.statusCode === "001") {
    dispatch(appNavigateTo({ goTo: "incomeSurrogate" }, "APP_NAVIGATE_TO"));
    updateState("incomeSurrogate", "kycDetails");
  }
  else if (MidMitc?.statusCode === "002") {
    dispatch(appNavigateTo({ goTo: "conditionalMITC" }, "APP_NAVIGATE_TO"));
    updateState("conditionalMITC", "conditionalMITC");
  }
  else if (MidMitc?.statusCode === "003") {
    dispatch(appNavigateTo({ goTo: "applicationConscent" }, "APP_NAVIGATE_TO"));
    updateState("applicationConscent", "kycDetails");
  }
  else if (MidMitc?.statusCode === "004") {
    dispatch(appNavigateTo({ goTo: "kycDetails" }, "APP_NAVIGATE_TO"));
    updateState("downsell", "kycDetails");
  }
  else if (MidMitc?.statusCode === "005") {
    dispatch(appNavigateTo({ goTo: "VkycStatus" }, "APP_NAVIGATE_TO"));
    updateState("VkycStatus", "kycDetails");
  }
  else if (MidMitc?.statusCode === "007") {
    if(isPartnerChannelCode(userDetail.channelCode))
    { 
      dispatch({ type: types.SET_WIP_STATUS, payload: { errorCode: "ERR10" }, });
                dispatch({
                    type: types.GENERIC_ERROR,
                    payload: { isGenericError: false, handleClick: null, exitEvent: null, errorMessage: "" },
                });
      dispatch(appNavigateTo({ goTo: "wip" }, "APP_NAVIGATE_TO"));
      updateState("wip", "MitMidc");
    }
    else
    {
      updateState("SD2Error", "sd2DataCapture");
      dispatch(appNavigateTo({ goTo: "sd2DataCapture" }, "APP_NAVIGATE_TO"));
    }
  }
}

export const getApiReqHeaders = (applicationNumber) => {
  return {
    "IDENTIFIER_1": applicationNumber,
    "IDENTIFIER_2": localStorage.getItem("visitorID")
  };
}